import { HintTooltip, useIsMobile } from '@brg/ui'
import { FC, PropsWithChildren } from 'react'
import {PaymentButtonSolid} from "../../payment/CheckOut/styles";
import { AppTester } from 'supporting';
import { useTheme } from 'styled-components';

interface PaymentButtonWithHintProps {
    disabled?: boolean
    onClick?: () => void
    hintText?: string
    w?: string
    closeToRightCorner?: boolean
    buttonTheme?: string
    isGift?: boolean
    fullWidth?: boolean
    noWidthLimitation?: boolean
}

export const PaymentButtonWithHint: FC<PropsWithChildren<PaymentButtonWithHintProps>> = (props) => {
    const { hintText, closeToRightCorner, disabled, onClick, w, buttonTheme, isGift, children, fullWidth, noWidthLimitation } = props
    const theme = useTheme();
    const isMobile = useIsMobile();
    const isDeziiignBooks = AppTester.isBooksMain();
    return (
        hintText ?
            <HintTooltip
                text={hintText}
                w={(isMobile || fullWidth) ? '100%' : ''}
                closeToRightCorner={closeToRightCorner}
                onWhiteBg
            >
                <PaymentButtonSolid isGift={isGift} buttonTheme={buttonTheme} disabled={disabled} onClick={onClick} fullWidth={fullWidth} noWidthLimitation={noWidthLimitation}>
                    {children}
                </PaymentButtonSolid>
            </HintTooltip> :
            <PaymentButtonSolid isGift={isGift} disabled={disabled} onClick={onClick} fullWidth={fullWidth} noWidthLimitation={noWidthLimitation}>
                {children}
            </PaymentButtonSolid>
    )
}
import { HintTooltip, useIsMobile } from '@brg/ui'
import { FC, PropsWithChildren } from 'react'
import {PaymentButtonSolid} from "../../payment/CheckOut/styles";
import { AppTester } from 'supporting';
import { useTheme } from 'styled-components';

interface PaymentButtonWithHintProps {
    disabled?: boolean
    onClick?: () => void
    hintText?: string
    w?: string
    closeToRightCorner?: boolean
    buttonTheme?: string
    isGift?: boolean
    fullWidth?: boolean
    noWidthLimitation?: boolean
}

export const PaymentButtonWithHint: FC<PropsWithChildren<PaymentButtonWithHintProps>> = (props) => {
    const { hintText, closeToRightCorner, disabled, onClick, w, buttonTheme, isGift, children, fullWidth, noWidthLimitation } = props
    const theme = useTheme();
    const isMobile = useIsMobile();
    const isDeziiignBooks = AppTester.isBooksMain();
    return (
        hintText ?
            <HintTooltip
                text={hintText}
                w={(isMobile || fullWidth) ? '100%' : ''}
                closeToRightCorner={closeToRightCorner}
                onWhiteBg
            >
                <PaymentButtonSolid isGift={isGift} buttonTheme={buttonTheme} disabled={disabled} onClick={onClick} fullWidth={fullWidth} noWidthLimitation={noWidthLimitation}>
                    {children}
                </PaymentButtonSolid>
            </HintTooltip> :
            <PaymentButtonSolid isGift={isGift} disabled={disabled} onClick={onClick} fullWidth={fullWidth} noWidthLimitation={noWidthLimitation}>
                {children}
            </PaymentButtonSolid>
    )
}
